//import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';
import { truncateForLink, sdgs, slug, getValFrmDict } from '../../data';
import sb from './sb.module.scss';

import { useApiProviderCtx } from '../../context/api';
export const openNav = () => {
  document.getElementById('mySidenav').style.width = '310px';
};

export const closeNav = () => {
  document.getElementById('mySidenav').style.width = '0';
};

export default function Sidebar() {
  const { userbaselink } = useApiProviderCtx();
  //onclick="closeNav()"

  /*	function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
  document.getElementById("main").style.marginLeft = "250px";
  document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
  document.getElementById("main").style.marginLeft= "0";
  document.body.style.backgroundColor = "white";
}*/

  return (
    <div id="mySidenav" className={sb.sidenav}>
      <div className={sb.mn}>
        <div className={sb.ht}>knowledge For development</div>
        <div
          onClick={() => {
            closeNav();
          }}
        >
          &times;
        </div>
      </div>
      {/*
  <a href="javascript:void(0)" className={sb.closebtn} ></a>*/}

      <a href="/en">Home</a>
      <a href="/en/about">About</a>
      <a href={`${userbaselink}/login`}>login</a>
      <a href={`${userbaselink}/register`}>register</a>
      {/*
  <a href="#">Services</a>
  <a href="#">Clients</a>*/}
      <a href="#">Contact</a>

      <div className={sb.mn}>
        <div className={sb.ht}>sustainable development goals</div>
        <div></div>
      </div>

      {sdgs?.map((n, i) => {
        return (
          <div key={i}>
            <a href={`/en/${slug(n?.name)}`}>{n.name}</a>
          </div>
        );
      })}
    </div>
  );
}
